import { Form, FormInstance } from "antd";
import { FeeOverridePart } from "../../../../../Account/components/View/Admin/Details/components/PayeeDisbursements/components/FeeOverridePart";
import { DisbursementsMethodPart } from "../../../../../Account/components/View/Admin/Details/components/PayeeDisbursements/components/DisbursementMethodPart";
import { MainPart } from "../../../../../Account/components/View/Admin/Details/components/PayeeDisbursements/components/MainPart";
import { useSetInitialValues } from "../hooks/useSetInitialValues";
import { FormButtons } from "./FormButtons";
import { Loader } from "../../../../../../components/Loader";
import { useCallback, useMemo } from "react";
import {
  PAYEE_TYPES,
  DISBURSEMENTS_METHOD_TYPES,
  DISBURSEMENTS_STATUS,
} from "../../../../../../lib/constants";

type CreateEditFormProps = {
  record: any;
  contractId: string;
  payeesNumber: {
    primaryBuyerNumber: number;
    primarySellerNumber: number;
  };
  isFormDisabled: boolean;
  isPaymentPosted: boolean;
  onCloseSideBar: (value: any, isOpen?: boolean) => void;
  saveRecord: (
    value: FormInstance,
    cancel: () => void,
    isNew: boolean,
    index: string | null
  ) => void;
  openDeleteModal: (id: string) => void;
  isHistoryOpened: boolean;
};

export const CreateEditForm = ({
  record,
  contractId,
  payeesNumber,
  isFormDisabled,
  isPaymentPosted,
  onCloseSideBar,
  saveRecord,
  openDeleteModal,
  isHistoryOpened,
}: CreateEditFormProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const { disbursementMethodState, isLoading } = useSetInitialValues(
    record,
    form
  );

  const initial = useMemo(
    () => ({
      type: PAYEE_TYPES[0].value,
      method: DISBURSEMENTS_METHOD_TYPES[0].value,
      status: DISBURSEMENTS_STATUS[0].value,
    }),
    []
  );

  const cancel = useCallback(
    () => onCloseSideBar(null, false),
    [onCloseSideBar]
  );

  const onSaveClicked = useCallback(
    (isNew: boolean) => saveRecord(form, cancel, isNew, record.index || null),
    [cancel, form, record.index, saveRecord]
  );

  return (
    <>
      <Form
        form={form}
        requiredMark={false}
        initialValues={initial}
        layout="vertical"
        className="w-100 pt-8 px-6 mb-4 payee-disbursements-form overflow-y-auto payment-disbursements"
        disabled={isFormDisabled || isPaymentPosted}
      >
        {!isLoading ? (
          <>
            <MainPart
              form={form}
              payeesNumber={payeesNumber}
              isFormDisabled={isFormDisabled || isPaymentPosted}
              isHistoryOpened={isHistoryOpened}
              isPayment
            />
            <DisbursementsMethodPart
              form={form}
              contractId={contractId}
              disbursementMethodState={disbursementMethodState}
              isFormDisabled={isFormDisabled || isPaymentPosted}
              isHistoryOpened={isHistoryOpened}
              isPayment
            />
            {!isHistoryOpened && (
              <FeeOverridePart
                form={form}
                isFormDisabled={isFormDisabled || isPaymentPosted}
              />
            )}
          </>
        ) : (
          <Loader fontSize="64px" />
        )}
      </Form>
      <FormButtons
        record={record}
        isFormDisabled={isFormDisabled}
        isPaymentPosted={isPaymentPosted}
        cancel={cancel}
        onSaveClick={onSaveClicked}
        openDeleteModal={openDeleteModal}
      />
    </>
  );
};
